import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import { Modal } from 'components/migrated/modal';
import { GenericTable } from 'components/migrated/generictable';
import { useApi } from 'services/api';
import Cookies from 'universal-cookie';
import { useSnackbar } from 'hooks';
import { useStyles } from './styles';

type ContactInfo = {
  cdGep: number;
  nmGep: string;
  analistas: string;
  gerentes: string;
};

type Props = {
  isOpen: boolean;
  handleClose: () => void;
};

export const ContactsModal = ({ handleClose, isOpen }: Props) => {
  const { Snackbar, toggleSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState<boolean>();
  const [data, setData] = useState<ContactInfo[]>([]);

  const classes = useStyles();

  const { api, paths } = useApi();
  const cookies = new Cookies();

  async function loadContacts() {
    const personId = cookies.get('User-Code');
    try {
      setIsLoading(true);

      const { data } = await api.get<ContactInfo[]>(paths.contact.contactInfo, {
        params: { personId },
        headers: { userFunctionKey: '3416a75f4cea9109507cacd8e2f2aefc' }
      });

      setData(data);

      toggleSnackbar({
        message: 'Lista de contatos carregada!',
        type: 'success'
      });
    } catch {
      toggleSnackbar({
        message: 'Ocorreu um problema ao carregar informações. Por favor, informe ao suporte.',
        type: 'error'
      });
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (isOpen && !data.length) {
      loadContacts();
    }
  }, [isOpen, data]);

  const contactsColumns: any = [
    {
      key: 'group',
      header: 'GRUPO',
      headerAlign: 'left',
      cellAlign: 'left',
      customRender: (row: ContactInfo) => {
        const label = `${row.cdGep} - ${row.nmGep}`;
        return <div>{label}</div>;
      }
    },
    {
      key: 'managers',
      header: 'DEPTO DE PRODUTOS - GERENTES',
      headerAlign: 'left',
      cellAlign: 'left',
      customRender: (row: ContactInfo) => {
        const managers = row.gerentes ? row.gerentes.split(', ') : [];
        if (managers.length === 0) {
          return <div>-</div>;
        }
        const managersNames = managers.map((manager: string) => {
          const [name, email] = manager.split(' <');
          return { name, email: email ? email.replace('>', '') : '-' };
        });
        return (
          <div>
            {managersNames.map((manager: { name: string; email: string }, index: number) => (
              <div key={index} style={{ marginTop: index > 0 ? '1em' : 0 }}>
                <b>{manager.name}</b>
                <div>{manager.email}</div>
              </div>
            ))}
          </div>
        );
      }
    },
    {
      key: 'analysts',
      header: 'DEPTO DE PRODUTOS - ANALISTAS',
      headerAlign: 'left',
      cellAlign: 'left',
      customRender: (row: ContactInfo) => {
        const analysts = row.analistas ? row.analistas.split(', ') : [];
        if (analysts.length === 0) {
          return <div>-</div>;
        }
        const analystNames = analysts.map((analyst: string) => {
          const [name, email] = analyst.split(' <');
          return { name, email: email ? email.replace('>', '') : '-' };
        });
        return (
          <div>
            {analystNames.map((analyst: { name: string; email: string }, index: number) => (
              <div key={index} style={{ marginTop: index > 0 ? '1em' : 0 }}>
                <b>{analyst.name}</b>
                <div>{analyst.email}</div>
              </div>
            ))}
          </div>
        );
      }
    }
  ];

  return (
    <>
      <Snackbar />
      <Modal title="Contatos" open={isOpen} onClose={handleClose}>
        {isLoading && (
          <div className={classes.loader}>
            <CircularProgress />
          </div>
        )}
        {!isLoading && <GenericTable columns={contactsColumns} data={data || []} maxHeight="620px" />}
      </Modal>
    </>
  );
};
